export const USERS = [
  { id:1, name:'Alex M.',   av:'A', color:'#818cf8', bg:'#1e1b4b', genres:['Sci-Fi','Thriller','Biography'],      watched:147, read:32,  saved:8,  mood:'Dark & Cerebral' },
  { id:2, name:'Jordan K.', av:'J', color:'#f472b6', bg:'#500724', genres:['Romance','Comedy','Memoir'],           watched:89,  read:61,  saved:14, mood:'Feel-Good'       },
  { id:3, name:'Sam T.',    av:'S', color:'#34d399', bg:'#022c22', genres:['Action','Fantasy','History'],          watched:203, read:18,  saved:6,  mood:'Adventurous'     },
  { id:4, name:'River L.',  av:'R', color:'#fb923c', bg:'#431407', genres:['Documentary','Mystery','Philosophy'],  watched:64,  read:94,  saved:22, mood:'Thoughtful'      },
];

export const MOODS = [
  { id:'all',       e:'✦', l:'All'       },
  { id:'thrilling', e:'⚡', l:'Thrilling' },
  { id:'chill',     e:'🌙', l:'Chill'     },
  { id:'inspiring', e:'🌟', l:'Inspiring' },
  { id:'dark',      e:'🖤', l:'Dark'      },
  { id:'funny',     e:'😄', l:'Funny'     },
  { id:'romantic',  e:'🌹', l:'Romantic'  },
  { id:'action',    e:'💥', l:'Action'    },
];

// trailerUrl = full YouTube URL used by react-player
export const ITEMS = [
  {
    id:1, type:'movie', title:'Dune: Part Two', year:'2024', by:'Denis Villeneuve',
    img:'https://images.unsplash.com/photo-1614728894747-a83421e2b9c9?w=900&q=80',
    trailerUrl:'https://www.youtube.com/watch?v=Way9Dexny3w',
    tags:['Epic','Sci-Fi','Adaptation'], score:97, stars:4.8,
    runtime:'166 min', genre:'Sci-Fi / Adventure', rated:'PG-13',
    desc:'Paul Atreides unites with Chani and the Fremen to wage war against House Harkonnen across the desert expanse of Arrakis.',
    longDesc:'Paul Atreides unites with Chani and the Fremen while on a warpath of revenge against the conspirators who destroyed his family. Facing a choice between the love of his life and the fate of the universe, he must prevent a terrible future only he can foresee.',
    reason:'Matches your love of expansive sci-fi world-building and auteur cinema',
    mood:['thrilling','dark','action'], users:[1,3],
    cast:['Timothée Chalamet','Zendaya','Rebecca Ferguson','Josh Brolin'],
    awards:'5 Academy Award Nominations',
  },
  {
    id:2, type:'movie', title:'Oppenheimer', year:'2023', by:'Christopher Nolan',
    img:'https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?w=900&q=80',
    trailerUrl:'https://www.youtube.com/watch?v=uYPbbksJxIg',
    tags:['Biography','Thriller','IMAX'], score:94, stars:4.7,
    runtime:'180 min', genre:'Biography / Drama', rated:'R',
    desc:'The story of J. Robert Oppenheimer and his role in the development of the atomic bomb during the Manhattan Project.',
    longDesc:'The story of American scientist J. Robert Oppenheimer and his role in the development of the atomic bomb. During World War II, Lt. Gen. Leslie Groves Jr. appoints physicist Oppenheimer to work on the top-secret Manhattan Project.',
    reason:'High correlation with your biography and historical thriller viewing history',
    mood:['thrilling','dark','inspiring'], users:[1,4],
    cast:['Cillian Murphy','Emily Blunt','Matt Damon','Robert Downey Jr.'],
    awards:'7 Academy Awards including Best Picture',
  },
  {
    id:3, type:'movie', title:'Poor Things', year:'2023', by:'Yorgos Lanthimos',
    img:'https://images.unsplash.com/photo-1574169208507-84376144848b?w=900&q=80',
    trailerUrl:'https://www.youtube.com/watch?v=RlbR5N6veqw',
    tags:['Fantasy','Dark Comedy','Drama'], score:93, stars:4.6,
    runtime:'141 min', genre:'Fantasy / Comedy', rated:'R',
    desc:'A young woman brought back to life by an unorthodox scientist runs off on a whirlwind adventure across the continents.',
    longDesc:'Brought back to life by an brilliant, unorthodox scientist, Bella Baxter escapes with a debauched lawyer on a whirlwind adventure. Free from prejudice, she grows steadfast in her purpose to stand for equality and liberation.',
    reason:'Strong overlap with your arthouse and dark comedy preferences',
    mood:['dark','funny'], users:[2,4],
    cast:['Emma Stone','Mark Ruffalo','Willem Dafoe'],
    awards:'4 Academy Awards including Best Actress',
  },
  {
    id:4, type:'movie', title:'The Holdovers', year:'2023', by:'Alexander Payne',
    img:'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=900&q=80',
    trailerUrl:'https://www.youtube.com/watch?v=AhKGFa69Lkw',
    tags:['Comedy','Drama','Heartwarming'], score:91, stars:4.6,
    runtime:'133 min', genre:'Comedy / Drama', rated:'R',
    desc:'A cantankerous history teacher stranded on campus over the holidays forms an unlikely bond with a troubled student.',
    longDesc:'A cantankerous prep school teacher is forced to remain on campus over Christmas with a handful of students who have nowhere to go, forming an unlikely bond with a troubled student and the school\'s head cook.',
    reason:'Bridges your comedy interest with character-driven drama preferences',
    mood:['chill','funny','inspiring'], users:[2,3],
    cast:['Paul Giamatti','Dominic Sessa','Da\'Vine Joy Randolph'],
    awards:'Academy Award for Best Supporting Actress',
  },
  {
    id:5, type:'movie', title:'Saltburn', year:'2023', by:'Emerald Fennell',
    img:'https://images.unsplash.com/photo-1478720568477-152d9b5b37df?w=900&q=80',
    trailerUrl:'https://www.youtube.com/watch?v=gMqIuDsVbAo',
    tags:['Thriller','Mystery','Psychological'], score:89, stars:4.3,
    runtime:'127 min', genre:'Psychological Thriller', rated:'R',
    desc:'A young Oxford student becomes consumed by his friendship with a classmate and is invited to his eccentric family\'s estate for the summer.',
    longDesc:'Struggling to find his place at Oxford, Oliver Quick finds himself drawn into the world of charming aristocrat Felix Catton, who invites him to Saltburn for a summer never to be forgotten.',
    reason:'Strong overlap with your psychological thriller watch history',
    mood:['dark','thrilling'], users:[1,4],
    cast:['Barry Keoghan','Jacob Elordi','Rosamund Pike','Carey Mulligan'],
    awards:'BAFTA Nominated',
  },
  {
    id:6, type:'movie', title:'Past Lives', year:'2023', by:'Celine Song',
    img:'https://images.unsplash.com/photo-1502209524164-acea936639a2?w=900&q=80',
    trailerUrl:'https://www.youtube.com/watch?v=kA7-0os0bQ0',
    tags:['Romance','Drama','Indie'], score:96, stars:4.9,
    runtime:'106 min', genre:'Romance / Drama', rated:'PG-13',
    desc:'Two childhood sweethearts separated by continents reconnect over three decades, questioning love, fate, and the roads not taken.',
    longDesc:'Nora and Hae Sung, deeply connected childhood friends, are separated when Nora\'s family emigrates from South Korea. Two decades later, they reunite in New York City for one week, confronting love, loss, and the lives they could have led.',
    reason:'Users with your romantic drama taste gave this 5★ universally',
    mood:['chill','romantic'], users:[2,4],
    cast:['Greta Lee','Teo Yoo','John Magaro'],
    awards:'2 Academy Award Nominations',
  },
  {
    id:7, type:'book', title:'Fourth Wing', year:'2023', by:'Rebecca Yarros',
    img:'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=900&q=80',
    tags:['Fantasy','Romance','Dragons'], score:93, stars:4.5,
    runtime:'528 pages', genre:'Fantasy Romance', rated:'Adult',
    desc:'A dragon rider academy, deadly trials, and a forbidden romance — one of the biggest fantasy debuts in years.',
    longDesc:'Twenty-year-old Violet Sorrengail was supposed to enter the Scribe Quadrant. But fate has other plans. Now she must train alongside dragon riders — with fewer rules and far more at stake.',
    reason:'89% of users with your fantasy preferences rate this 5★',
    mood:['thrilling','romantic','inspiring'], users:[2,3],
    cast:['Rebecca Yarros'], awards:'#1 NYT Bestseller',
  },
  {
    id:8, type:'book', title:'Tomorrow, and Tomorrow', year:'2022', by:'Gabrielle Zevin',
    img:'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=900&q=80',
    tags:['Literary Fiction','Friendship','Art'], score:95, stars:4.7,
    runtime:'416 pages', genre:'Literary Fiction', rated:'Adult',
    desc:'Two prodigious game designers forge a creative partnership across three decades of friendship, love, and heartbreak.',
    longDesc:'On a bitter-cold day in December 1987, two college students fall into a deep creative collaboration. A richly imagined novel about love, creativity, and what it means to be an artist in a capitalist world.',
    reason:'Near-perfect tag overlap with every book in your reading history',
    mood:['chill','inspiring','romantic'], users:[1,4],
    cast:['Gabrielle Zevin'], awards:'Pulitzer Prize Finalist',
  },
  {
    id:9, type:'product', title:'Sony WH-1000XM5', year:'2024', by:'Sony',
    img:'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=900&q=80',
    tags:['Audio','ANC','Premium'], score:95, stars:4.8,
    runtime:'30hr battery', genre:'Headphones', rated:'$349',
    desc:'Industry-leading noise cancellation with 30-hour battery life in Sony\'s most refined flagship wireless headphones.',
    longDesc:'Eight microphones and two processors power Precise Voice Pickup Technology. Industry-leading noise cancellation powered by the Integrated Processor V1. Exceptional sound with 30mm drivers and Hi-Res Audio.',
    reason:'Browsed 3× — purchased by 89% of users with your cart history',
    mood:['chill'], users:[1,2,3],
    cast:['Sony Electronics'], awards:'Best in Class 2024',
  },
  {
    id:10, type:'product', title:'Kindle Paperwhite', year:'2023', by:'Amazon',
    img:'https://images.unsplash.com/photo-1592496431122-2349e0fbc666?w=900&q=80',
    tags:['E-Reader','Waterproof','Reading'], score:92, stars:4.7,
    runtime:'Weeks of battery', genre:'E-Reader', rated:'$139',
    desc:'300 ppi glare-free display, weeks of battery life, and fully waterproof — the perfect reading companion.',
    longDesc:'Now with a 6.8" display and thinner borders, adjustable warm light, and 20% faster page turns. With a single charge lasting weeks, Kindle Paperwhite goes everywhere you go.',
    reason:'High affinity with users who match your reading frequency of 61 books/year',
    mood:['chill'], users:[2,4],
    cast:['Amazon Devices'], awards:"Editors' Choice 2023",
  },
  {
    id:11, type:'product', title:'Apple AirPods Pro 2', year:'2023', by:'Apple',
    img:'https://images.unsplash.com/photo-1600294037681-c80b4cb5b434?w=900&q=80',
    tags:['Audio','Spatial','ANC'], score:90, stars:4.6,
    runtime:'30hr with case', genre:'Earbuds', rated:'$249',
    desc:'Adaptive Audio, personalized Spatial Audio, and up to 30 hours of battery with the MagSafe charging case.',
    longDesc:'AirPods Pro feature Adaptive Audio — a new listening mode that dynamically blends Active Noise Cancellation and Transparency mode for the best possible audio experience in any environment.',
    reason:'Frequently purchased together with items in your browsing history',
    mood:['chill','thrilling'], users:[1,3],
    cast:['Apple Inc.'], awards:'Best Earbuds 2023',
  },
];

export const REVIEWS = [
  { id:1, name:'Maya R.',  av:'M', color:'#818cf8', bg:'#1e1b4b', stars:5, text:'The AI recommendations are eerily accurate. Found three new favourites I\'d never have discovered. The trailer feature is incredible!',              tag:'Sci-Fi Lover', date:'2 days ago'   },
  { id:2, name:'Tom A.',   av:'T', color:'#f472b6', bg:'#500724', stars:5, text:'Switched from Netflix\'s rec system and never looked back. Mood filter + trailer previews in one place is a total game changer.',                        tag:'Cinephile',    date:'1 week ago'   },
  { id:3, name:'Priya S.', av:'P', color:'#34d399', bg:'#022c22', stars:5, text:'I love how it explains WHY it recommends something. Feels personal, not algorithmic. Bookmarked 8 titles in my first session!',                         tag:'Book Nerd',    date:'2 weeks ago'  },
  { id:4, name:'Kai L.',   av:'K', color:'#fb923c', bg:'#431407', stars:4, text:'The collaborative filtering is impressive. Reading list quality has doubled. The AI chat is surprisingly useful for niche recommendations.',             tag:'Reader',       date:'3 weeks ago'  },
  { id:5, name:'Dana W.',  av:'D', color:'#22d3ee', bg:'#0a2a1a', stars:5, text:'Watching trailers inside the app before deciding what to watch is everything. No more bouncing between tabs. 10/10 experience.',                        tag:'Movie Buff',   date:'1 month ago'  },
];

export const LOADING_STEPS = [
  'Fetching your taste profile…',
  'Running collaborative filter…',
  'Computing similarity vectors…',
  'Applying content-based scoring…',
  'Ranking predictions by match %…',
];

export const AI_REPLIES = [
  "Based on your profile, I'd suggest **Annihilation** — cerebral sci-fi with stunning visuals. 96% match!",
  "You might love **The Bear** on Hulu — intense, brilliantly written, completely unique. 93% match.",
  "For something cinematic: **Everything Everywhere All at Once** — a multiverse masterpiece. 97% match!",
  "Your mood suggests something uplifting. **Ted Lasso** is a 94% match — heartwarming and beautifully written.",
  "Based on your thriller history, **Severance** on Apple TV+ is perfect. Dark, thrilling, 95% match!",
  "You'd love **Killers of the Flower Moon** — historical, intense, brilliantly acted. 91% match.",
];
